var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[(_vm.showGrid)?_c('gridView'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }